import { isValidUuid } from '@orn/global/ids/uuid.js';
import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';
import { Link } from 'react-router-dom';

import InspectLink from '../../components/InspectLink';

import type { IToolLink } from './accountsView';

interface INameOrIdProps {
  name: string;
}

/** A name the API replaces with the raw id when the row it names is gone, the id linked like any other. */
export const NameOrId = ({ name }: INameOrIdProps) => (isValidUuid(name) ? <InspectLink id={name} /> : <>{name}</>);

interface IToolLinksProps {
  label: string;
  links: IToolLink[];
  className?: string;
}

/** A row of links out to other mops tools, each already scoped to the row it sits on. */
export const ToolLinks = ({ label, links, className }: IToolLinksProps) => (
  <nav aria-label={label} className={cx('flex items-baseline gap-1.5 text-xs', className)}>
    {links.map((link, index) => (
      <React.Fragment key={link.to}>
        {index > 0 && <span className="text-fg-quaternary">·</span>}
        <Link
          to={link.to}
          className="text-fg-brand-primary hover:text-fg-brand-secondary underline-offset-2 hover:underline"
        >
          {link.label}
        </Link>
      </React.Fragment>
    ))}
  </nav>
);
